import { useEffect, useRef, useState } from "react";
import { useRouteMatch, NavLink, useHistory } from "react-router-dom";
import { TitleText } from "../../ui/Text";
import { DropDownIcon } from "../../assets/svg/DropDownIcon";
import React from "react";
import styled, { keyframes } from "styled-components";
import { SCORECARD_URL } from "../../api/urls";
import { GetHook } from "../../api/api";
import { get } from "../../utils/get";
import { KPIAccordion } from "./KPIAccordion";
import { ObjectiveSubject } from "../../subjects/ObjectiveSubject";
import { StatusIcon } from "../../assets/svg/StatusIcon";
import moment from "moment";

interface IProps {
  scorecardId: string;
  perspectiveId: string;
  lastLocation: string | undefined;
  dateFilter: any;
}

const ObjectiveAccordion = ({ scorecardId, perspectiveId,lastLocation , dateFilter}: IProps) => {
  const [objData, setData] = useState<any>();
  const [isActive, setIsActive] = useState(false);
  const date = `2024-01-01/2024-12-31`;
  let { data } = GetHook(
    `${SCORECARD_URL}/${scorecardId}/objective?perspective_id=${perspectiveId}&interval=${date}`
  );

  const KPIcontent = useRef<any>(null);

  const { location } = useHistory();
  const { url } = useRouteMatch();

  const lastSegment = location.pathname.split("/").pop();

  useEffect(() => {
    const subscription = ObjectiveSubject.subscribe((payload) => {
      setData(payload);
    });
    return () => subscription.unsubscribe();
  }, []);

  const getColor = (score) => {
    switch (true) {
      case score >= 1 && score < 2:
        return "#D51067";
      case score >= 2 && score <= 3.9:
        return "#EDBC0C";
      case score > 3:
        return "#4BD041";
      case score >= 5:
        return "url(#grad2)";
      default:
        return "#D51067";
    }
  };

  data = Array.isArray(data) && data.length >= 1 ? data : [];
  
  return data.map((obj: any, index) => (
    <AccordionNavContainer key={index}>
      <ObjectiveItem
        onClick={() => {
          setIsActive(true);
          ObjectiveSubject.next(obj);
        }}
        isActive={(_match, location) =>
          !!get(location, "pathname", "").includes(get(obj, "objective_id"))
        }
        to={{
          pathname: `${url}/${scorecardId}/perspective/${perspectiveId}/objective/${get(
            obj,
            "objective_id"
          )}/${lastLocation}`,
          state: { from: lastLocation },
        }}
      >
        <TitleContainer>
          <StatusIconWrapper>
            <StatusIcon
              color={
                obj.id === get(objData, "[0]id")
                  ? getColor(get(objData, "[0].periodic_score"))
                  : getColor(get(obj, "periodic_score"))
              }
            />
          </StatusIconWrapper>
          <TitleText>{get(obj, "objective_name")}</TitleText>
        </TitleContainer>
        <DropDownIcon />
      </ObjectiveItem>
      {isActive && (
        <AccordionItemsWrapper2
          ref={KPIcontent}
          style={
            get(location, "pathname", "").includes(get(obj, "objective_id"))
              ? { maxHeight: "500px", opacity: 1 }
              : { maxHeight: 0, opacity: 0 }
          }
        >
          <KPIAccordion
            lastLocationO={lastSegment}
            scorecardId={scorecardId}
            objectiveId={get(obj, "objective_id")}
            perspectiveId={perspectiveId}
          />
        </AccordionItemsWrapper2>
      )}
    </AccordionNavContainer>
  ));
};

export default ObjectiveAccordion;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideDown = keyframes`
  from { max-height: 0; opacity: 0; }
  to { max-height: 500px; opacity: 1; }
`;

const rotateIcon = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(180deg); }
`;

const ObjectiveItem = styled(NavLink)`
  display: flex;
  padding: 1.5em 1.4em;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;

  &:hover {
    background-color: #f5f7ff;
  }

  &.active {
    background-color: #ffffff;
    border-left-color: #01A8CE;

    ${TitleText} {
      color: #01A8CE;
      font-weight: 600;
    }

    svg {
      animation: ${rotateIcon} 0.3s forwards;
    }
  }

  ${TitleText} {
    font-size: 14px;
  }
`;

const AccordionNavContainer = styled.div`
  display: grid;
  animation: ${fadeIn} 0.5s ease-out;
`;

const AccordionItemsWrapper2 = styled.div`
  display: grid;
  grid-template-rows: repeat(auto, 3.5em);
  grid-template-columns: 3em 1fr;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-left: 1.4em;
  animation: ${slideDown} 0.3s ease-out;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StatusIconWrapper = styled.span`
  padding-right: 0.8em;
  display: flex;
  align-items: center;
`;
